/**
 * Funciones genéricas para transformar datos a formatos utilizables en componentes
 */

/**
 * Transforma un array de clínicas a formato de opciones para Dropdown
 * @param {Array} clinicas - Array de objetos de clínicas
 * @returns {Array} Array de opciones con formato { key, text, value }
 */
export const transformClinicasToOptions = (clinicas) => {
  if (!Array.isArray(clinicas)) {
    return [];
  }
  return clinicas.map((clinica) => ({
    key: clinica.id,
    text: clinica.clinica_nombre,
    value: clinica.id
  }));
};

/**
 * Transforma un array de aseguradoras a formato de opciones para Dropdown
 * @param {Array} aseguradoras - Array de objetos de aseguradoras
 * @returns {Array} Array de opciones con formato { key, text, value }
 */
export const transformAseguradorasToOptions = (aseguradoras) => {
  if (!Array.isArray(aseguradoras)) {
    return [];
  }
  return aseguradoras.map((aseguradora) => ({
    key: aseguradora.id,
    text: aseguradora.short_name,
    value: aseguradora.id
  }));
};

/**
 * Transforma un array de provincias a formato de opciones para Dropdown
 * @param {Array} provincias - Array de objetos de provincias
 * @returns {Array} Array de opciones con formato { key, text, value }
 */
export const transformProvinciasToOptions = (provincias) => {
  if (!Array.isArray(provincias)) {
    return [];
  }
  return provincias.map((provincia) => ({
    key: provincia.id,
    text: provincia.nombre,
    value: provincia.id
  }));
};

/**
 * Transforma un array de localidades a formato de opciones para Dropdown
 * @param {Array} localidades - Array de objetos de localidades
 * @returns {Array} Array de opciones con formato { key, text, value, provincia }
 */
export const transformLocalidadesToOptions = (localidades) => {
  if (!Array.isArray(localidades)) {
    return [];
  }
  return localidades.map((localidad) => ({
    key: localidad.id,
    text: localidad.nombre,
    value: localidad.id,
    provincia: localidad.provincia
  }));
};
